import classnames from 'classnames';
import Icon from 'shared/components/icon/icon';

import styles from '../account-button.styl';


export default class AccountInfoButton extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
  };

  render() {
    const { className, onClick } = this.props;

    return (
      <Icon name="avatar"
            data-hook="simpleInfoButton"
            className={classnames(styles['account-info-button'], className)}
            onClick={onClick} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button/account-info-button/account-info-button.js